<div class="container-visualizacao">
    <div class="row container-options">
        <div class="col-12">
            <button type="button" class="btn btn-primary mr-2" (click)="insert()"><i class="fas fa-plus" aria-hidden="true"></i> Novo</button>
            
            <!-- Opções -->
            <div class="btn-group" *ngIf="options?.hasAnyOption()">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-none d-sm-inline-block">Opções</span>
                </button>
                <div class="dropdown-menu">
                    <!-- Import ERP V1 -->
                    <ng-template [ngIf]="options?.canImportErp_v1">
                        <a class="dropdown-item" (click)="importErp_v1()">
                            <i class="fas fa-download"></i> Importar do ERP
                        </a> 
                        <div class="dropdown-divider"></div>
                    </ng-template>

                    <a class="dropdown-item" *ngIf="options?.canImport" (click)="openImportModal()">
                        <i class="fas fa-download"></i> Importar via Excel
                    </a>
                </div>
            </div>      
            
            <span class="float-right">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="search()">
                        <i class="fas fa-search" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clearFilter()">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn" [class.btn-light]="!filterCollapse.isFilterDirty" [class.btn-danger]="filterCollapse.isFilterDirty"
                        (click)="filterCollapse.toggleCollapse()">
                        <i class="fas fa-filter" aria-hidden="true"></i>
                        <i [class]="filterCollapse.collapseIcon" aria-hidden="true"></i>
                    </button>
                </div>                
            </span>
        </div>
    </div>
    <div class="row container-table" #containerTable>
        <div class="col-12">
            <div class="row container-filter">
                <div class="col-12">
                   <sgt-condicao-pagamento-filter
                        [filter]="filter"
                        (filterInitialized)="onFilterInitialized()"
                        #filterCollapse>
                   </sgt-condicao-pagamento-filter>
                </div>
            </div> 
            
            <div class="row">
                <div class="col-12">
                    <table class="table table-striped table-hover datatables" id="tableCondicoesPagamentos">
                        <thead>
                                <tr>
                                    <th class="col-options"></th>
                                    <th class="col-codigo-integracao-erp text-right">Código ERP</th>
                                    <th class="col-nome">Nome</th>
                                    <th class="col-prazo-medio text-right">Prazo Médio</th>
                                    <th class="col-situacao text-center">Situação</th>
                                </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let entity of entities">
                                <td class="col-options">
                                    <a (click)="edit(entity)"><i class="fas fa-pencil-alt" aria-hidden="true"></i></a>
                                    <a (click)="delete(entity)"><i class="far fa-trash-alt" aria-hidden="true"></i></a>
                                </td>
                                <td class="col-codigo-integracao-erp text-right">{{entity.codigoIntegracaoErp}}</td>
                                <td class="col-nome">{{entity.nome}}</td>
                                <td class="col-prazo-medio text-right">{{entity.prazoMedio}}</td>
                                <td class="col-situacao text-center">
                                    <span class="badge badge-success" *ngIf="entity.situacao === 1">Ativa</span>
                                    <span class="badge badge-danger" *ngIf="entity.situacao === 2">Inativa</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>                      
                </div>
            </div>                   
        </div>
    </div>    
</div>

<!-- Modal para importar as Condições de Pagamento -->
<sgt-condicao-pagamento-import-modal
    idModal="condicaoPagamentoImportModal"
    (afterImport)="onAfterImport()"
    #importModal>
</sgt-condicao-pagamento-import-modal>